module.exports = __webpack_public_path__ + "static/img/b02.52d1036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dedicatedService/b02.png
// module id = kn9S
// module chunks = 1